export default function () {
  return [
    // Existing
    { key: 'email' },
    { key: 'orgId', type: 'org', selectProps: { clearable: true, multiple: false } },
    {
      key: 'brand',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      }
    },

    // Lead fields
    { key: 'firstName', label: 'firstName' },
    { key: 'lastName', label: 'lastName' },
    { key: 'phone', label: 'phone' },
    { key: 'country', label: 'country' },
    { key: 'language', label: 'language' },
    { key: 'deliveryDate', label: 'deliveryDate', type: 'date' },
    { key: 'statusUpdateTime', label: 'statusUpdate', type: 'dateTime' },
    { key: 'online', label: 'online', type: 'checkbox' },
    { key: 'isFtd', label: 'ftd', type: 'checkbox' },

    { key: 'trafficSource', label: 'trafficSource' },
    { key: 'subSource', label: 'subSource' },
    { key: 'clickId', label: 'clickId' },
    { key: 'page', label: 'page' },
    { key: 'brandStatus', label: 'status' },
    {
      key: 'campaign',
      label: 'campaign',
      type: 'campaign',
      props: {
        clearable: true,
        multiple: true
      }
    },
  ]
}
